<template>
  <div class="member-statistics">
    <div class="member-statistics-header">
      <h3>统计数据</h3>
      <mk-tabs v-model="activeName">
        <mk-tab-pane
          label="员工分享"
          name="first"
        />
        <mk-tab-pane
          label="用户转发"
          name="second"
        />
      </mk-tabs>
    </div>
    <div class="member-statistics-tips">
      <div class="left">
        共计 {{ totalMen }} 名{{ activeName === 'first' ? '员工分享' : '用户转发' }}，{{ activeName === 'first' ? '分享 ' + totalShare : '转发 ' + totalShare }} 次
      </div>
      <div
        class="right"
        @click="showVisible"
      >
        记录明细
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="member-statistics-search">
      <search-select-member
        :key="key"
        v-model="member"
        :type="type"
        :config="config"
        :placeholder="placeholder"
        @change="change"
      />

      <export-xlsx
        :api="bridgeMaterialStatisticsExportPost"
        :text="`导出${activeName==='first'?'员工':'用户'}数据`"
        type="default"
        width="120px"
        height="32px"
        icon="el-icon-download"
      />
    </div>
    <div class="list">
      <div class="list-header">
        <div class="list-header-sale">
          {{ activeName === 'first' ? '员工' : '用户昵称' }}
        </div>
        <div class="list-header-share">
          {{ activeName === 'first' ? '分享次数' : '转发次数' }}
        </div>
        <div class="list-header-pv">
          浏览量
        </div>
        <div class="list-header-uv">
          浏览人数
        </div>
      </div>
      <div class="list-content">
        <div
          v-for="(item,index) in list.slice(0,10)"
          :key="index"
          class="list-content-item"
        >
          <div class="list-content-item-sale">
            {{ item.name }}
            <mk-popover
              v-if="activeName !=='first' && item.isSyncWPContact"
              placement="top-start"
              title=""
              width="60"
              trigger="hover"
              popper-class="wx-icon-popover"
              content="已被添加为微信好友"
            >
              <ds-iconfont
                slot="reference"
                class="wx-icon"
                icon-class="iconweixinguanli"
                style="cursor: pointer; font-size: 18px;"
              />
            </mk-popover>
          </div>
          <div class="list-content-item-share">
            {{ item.countShare }}
          </div>
          <div class="list-content-item-pv">
            {{ item.pv }}
          </div>
          <div class="list-content-item-uv">
            {{ item.uv }}
          </div>
        </div>
      </div>
      <mk-pagination
        v-if="list && list.length > 0"
        class="page"
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        @current-change="currentChange"
      />
      <no-data v-else />
    </div>
    <member-statistics-detail
      v-if="visible"
      :init-active-name="activeName"
      :visible="visible"
      :base-data="baseData"
      @cancel="cancel"
    />
  </div>
</template>
<script>
import searchSelectMember from '@components/search-select-member'
import memberStatisticsDetail from './member-statistics-detail'
import noData from '@components/no-data'
export default {
  components: {
    searchSelectMember,
    memberStatisticsDetail,
    noData
  },
  props: {
    baseData: {
      type: [Object, Array],
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      activeName: 'first',
      member: '',
      key: Number(new Date().getTime()) + '_acive',
      visible: false,
      list: [],
      total: 0,
      page: 1,
      totalMen: 0,
      totalShare: 0
    }
  },
  computed: {
    type () {
      if (this.activeName === 'first') {
        return 'sale'
      } else {
        return 'clue'
      }
    },
    config () {
      if (this.activeName === 'first') {
        return {
          id: 'userId',
          name: 'name'
        }
      } else {
        return {
          id: 'unionId',
          name: 'nickName'
        }
      }
    },
    placeholder () {
      if (this.activeName === 'first') {
        return '输入员工名搜索'
      } else {
        return '输入用户昵称搜索'
      }
    },
    // 导出分享统计(区分员工，用户)
    bridgeMaterialStatisticsExportPost () {
      return {
        name: MKMATERIALSVC.MaterialApi.bridgeMaterialStatisticsExportPost,
        params: {
          materialId: this.$route.query.id,
          type: this.activeName === 'first' ? 'sale' : 'clue'
        }
      }
    }
  },
  watch: {
    activeName () {
      this.member = ''
      this.page = 1
      this.key = Number(new Date().getTime()) + '_acive'
      this.bridgeMaterialStatisticsPost()
    }
  },
  activated () {
    this.bridgeMaterialStatisticsPost()
  },
  methods: {
    async bridgeMaterialStatisticsPost () {
      let metas = {}
      if (this.member !== '') {
        this.activeName === 'first' ? metas.userId = this.member : metas.unionId = this.member
      }
      const res = await MKMATERIALSVC.MaterialApi.bridgeMaterialStatisticsPost({
        materialId: this.$route.query.id,
        page: this.page,
        pageSize: 10,
        type: this.activeName === 'first' ? 'sale' : 'clue',
        ...metas
      })
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
        this.totalShare = res.data.totalShare
        this.totalMen = res.data.totalMen
      } else {
        this.list = []
        this.total = 0
      }
    },
    showVisible () {
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    currentChange (e) {
      this.page = e
      this.bridgeMaterialStatisticsPost()
    },
    change () {
      this.page = 1
      this.bridgeMaterialStatisticsPost()
    }
  }
}
</script>
<style lang="scss" scoped>
.member-statistics {
  width: 100%;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;

  /deep/ .el-tabs__header {
    margin: 0 !important;
  }

  /deep/ .el-tabs__nav-scroll {
    padding: 0 !important;

    .el-tabs__item {
      font-size: 13px !important;
      height: 54px !important;
      line-height: 54px !important;
      font-weight: normal !important;
      outline: none !important;
      padding: 0 10px !important;
    }

    .el-tabs__item.is-active {
      color: #009cff !important;
    }

    .el-tabs__active-bar {
      height: 2px !important;
      background: #009cff !important;
    }
  }

  // /deep/ .el-tabs__active-bar {
  //   padding: 0 10px;
  //   margin-left: -10px;
  // }

  /deep/ .el-tabs__nav-wrap {
    padding: 0 !important;

    &::after {
      display: none !important;
    }
  }

  .member-statistics-header {
    height: 54px;
    padding: 0 20px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #d9d9d9;

    h3 {
      font-size: 16px;
      color: #262626;
      // font-weight: 500;
      font-weight: 500;
    }
  }

  .member-statistics-tips {
    width: 100%;
    height: 36px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    // border-bottom: 1px solid #f0f0f0;
    border-bottom: 1px solid #d9d9d9;
    font-size: 13px;

    .left {
      color: #595959;
    }

    .right {
      color: #009cff;
      cursor: pointer;

      .el-icon-arrow-right {
        margin-left: -3px;
      }
    }
  }

  .member-statistics-search {
    display: flex;
    padding: 10px 0;
    width: calc(100% - 40px);
    margin: 0 auto;

    .select-member {
      flex: 1;
      margin-right: 10px;
    }
  }

  .list {
    width: calc(100% - 40px);
    margin: 0 auto;

    .list-header {
      display: flex;
      justify-content: space-between;
      color: #475166;
      font-size: 13px;

      .list-header-sale {
        flex-basis: 40%;
        // font-weight: 500;
        font-weight: 500;
      }

      .list-header-share,
      .list-header-pv,
      .list-header-uv {
        flex: 1;
        text-align: right;
        // font-weight: 500;
        font-weight: 500;
      }
    }

    .list-content {
      .list-content-item {
        height: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #595959;
        font-size: 13px;
        margin-top: 12px;

        .list-content-item-sale {
          flex-basis: 40%;
        }

        .list-content-item-share,
        .list-content-item-pv,
        .list-content-item-uv {
          flex: 1;
          text-align: right;
        }
      }
    }
  }

  .page {
    // display: inline-block;
    // max-width: calc(100% - 2px);
    // margin-left: 50%;
    // transform: translateX(-50%);
    margin-left: -16px;
    padding-bottom: 14px;
  }

  /deep/ .no-data {
    margin-top: 64px;
  }

  .wx-icon {
    color: #d9d9d9;

    &:hover {
      color: #009cff;
    }
  }
}
</style>
<style lang="scss">
  .wx-icon-popover {
    padding: 10px !important;
    width: auto !important;
    min-width: auto !important;
    font-size: 12px;
  }
</style>
